import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { RouterLink } from '@angular/router';

import { IconModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { RoutingItemComponent } from './components/routing-item';

@Component({
  selector: 'iw-mobile-nav, [iwMobileNav]',
  templateUrl: './mobile-nav.component.html',
  styleUrls: ['./mobile-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, IconModule, RoutingItemComponent, RouterLink],
})
export class MobileNavComponent {
  readonly openMenu = output<void>();

  readonly navRoutingItems = [
    {
      link: '/mobile/home',
      iconName: 'home',
      i18nKey: 'shell.bottom.nav.home',
    },
    {
      link: '/mobile/fiat-wallets',
      iconName: 'fiat',
      i18nKey: 'shell.bottom.nav.fiat',
    },
    {
      link: '/mobile/crypto-wallets',
      iconName: 'crypto',
      i18nKey: 'shell.bottom.nav.crypto',
    },
    {
      link: '/mobile/cards',
      iconName: 'cards',
      i18nKey: 'shell.bottom.nav.cards',
    },
  ];
}
